module.exports = __webpack_public_path__ + "static/img/flexiquote-logo-light.a23e0fe6.svg";